import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VuetifyConfirm from 'vuetify-confirm'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import DatetimePicker from 'vuetify-datetime-picker'
import { dateFilter } from 'vue-date-fns'
import VueNativeNotification from 'vue-native-notification'

Vue.use(Vuetify)
const vuetify = new Vuetify({})
Vue.use(VuetifyConfirm, { vuetify })
Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})
Vue.use(DatetimePicker)
Vue.use(TiptapVuetifyPlugin, { vuetify, iconsGroup: 'mdi'})
Vue.filter("date", dateFilter)

export default vuetify
